import React from "react";
import Pagination from "react-bootstrap/Pagination";

const ListingPagination = () => {
  return (
    <div className='pagination-content'>
      <Pagination>
        <Pagination.Prev />
        <Pagination.Item>{1}</Pagination.Item>

        <Pagination.Item active>{2}</Pagination.Item>

        <Pagination.Item>{3}</Pagination.Item>
        <Pagination.Next />
      </Pagination>
    </div>
  );
};

export default ListingPagination;
